'use es6';

import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
export const editChatFlowDeepLink = ({
  portalId = PortalIdParser.get(),
  chatflowId
}) => `${getFullUrl('app')}/chatflows/${portalId}/edit/live-chat/${chatflowId}/build`;